import { queryAll, query, fromId } from '../utils/utils.js';
import * as bootstrap from 'bootstrap';


export class ContactUs {
    root = query('body');

    constructor() {
		this.init();
    }

    init() {
		var modal = new bootstrap.Modal(document.getElementById('contactUs-Modal'), {
		})

		const contactUsButtons = queryAll('.contact-us-launch');
		contactUsButtons.forEach((btn , i) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				modal.show();
			});
		});

	}

}
